import { SectionTitle } from "@porchpass/ui";
import { SlideUpModal } from "src/components/SlideUpModal";

type CostBreakdownModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
};

export default ({ isOpen, closeHandler }: CostBreakdownModalProps) => {
  return (
    <SlideUpModal
      hasIcon
      title="Cost Definition"
      isOpen={isOpen}
      hasDismissButton={false}
      actionButtonClickHandler={closeHandler}
      actionButtonText="Got it"
      closeHandler={closeHandler}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <SectionTitle title="Interest Rate" size="md" />
          <p className="text-base leading-[22.4px] text-[#111827]">
            The percentage of a loan or debt that is charged as interest to the
            borrower, typically expressed as an annual percentage of the loan
            amount. It is essentially the cost of borrowing money or the return
            for lending money. High interest rates make loans more expensive,
            while low interest rates make them cheaper.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <SectionTitle title="Home Insurance" size="md" />
          <p className="text-base leading-[22.4px] text-[#111827]">
            Also “homeowners insurance,” home insurance is a policy that covers
            damage to the home, loss of belongings, and liability for accidents
            on the property. The specifics vary by policy.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <SectionTitle title="Property Tax" size="md" />
          <p className="text-base leading-[22.4px] text-[#111827]">
            Property taxes are used to fund local government services such as
            schools, road construction and maintenance, public safety, and other
            community infrastructure. The rate of property tax varies by
            location and is typically expressed as a percentage of the
            property&#39;s assessed value.
          </p>
        </div>
      </div>
    </SlideUpModal>
  );
};
